var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpenseeyes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 7.938 10.723 3.785v32.8L1 40.738v-32.8z",
    fill: "#3D6627",
    stroke: "#C8C7B1",
    strokeWidth: 0.114
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.723 11.723 18.293-6.939v32.8l-18.293 6.939",
    fill: "#3D6627"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.723 11.723 18.293-6.939v32.8l-18.293 6.939",
    stroke: "#C8C7B1",
    strokeWidth: 0.114
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.938 20.554 1l9.335 3.785-18.166 6.938L1 7.938z",
    fill: "#7E976E",
    stroke: "#274116",
    strokeWidth: 0.126
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64 7.939 20.554 1.63l7.822 3.154-16.653 6.307L2.766 7.94",
    stroke: "#3D6627",
    strokeWidth: 0.252
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m1 9.2 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262 10.723 3.785zm0 1.261 10.723 3.785zm0 1.262 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262L11.723 25.6zm0 1.261 10.723 3.785zm0 1.262 10.723 3.784zM1 25.6l10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262 10.723 3.785zm0 1.261 10.723 3.785zm0 1.262 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262L11.723 42zm0 1.261 10.723 3.785z",
    fill: "#CCE0D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m1 9.2 10.723 3.785M1 10.462l10.723 3.784M1 11.723l10.723 3.785M1 12.985l10.723 3.784M1 14.246l10.723 3.785M1 15.508l10.723 3.785M1 16.768l10.723 3.785M1 18.031l10.723 3.785M1 19.293l10.723 3.784M1 20.554l10.723 3.785M1 21.816 11.723 25.6M1 23.077l10.723 3.785M1 24.339l10.723 3.784M1 25.6l10.723 3.785M1 26.862l10.723 3.784M1 28.123l10.723 3.785M1 29.385l10.723 3.784M1 30.646l10.723 3.785M1 31.908l10.723 3.785M1 33.169l10.723 3.785M1 34.431l10.723 3.785M1 35.693l10.723 3.784M1 36.954l10.723 3.785M1 38.216 11.723 42M1 39.477l10.723 3.785",
    stroke: "#274116",
    strokeWidth: 0.252
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.723 12.985 29.89 6.046zm0 1.261L29.89 7.308zm0 1.262L29.89 8.569zm0 1.262L29.89 9.83zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261L29.89 16.14zm0 1.262L29.89 17.4zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261 18.166-6.938zm0 1.262 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261L29.89 32.54zm0 1.262L29.89 33.8zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939z",
    fill: "#CCE0D1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.723 12.985 29.89 6.046m-18.166 8.2L29.89 7.308m-18.166 8.2L29.89 8.569m-18.166 8.2L29.89 9.832m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2L29.89 16.14m-18.166 8.2L29.89 17.4m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2L29.89 32.54m-18.166 8.2L29.89 33.8M11.723 42l18.166-6.938m-18.166 8.2 18.166-6.939",
    stroke: "#274116",
    strokeWidth: 0.252
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m8.443 5.162 9.588 3.785 4.415-1.64-9.461-3.785",
    fill: "#E5E5D5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m8.443 5.162 9.588 3.785 4.415-1.64-9.461-3.785",
    stroke: "#E5E5D5",
    strokeWidth: 0.013
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.031 8.947v33.179l4.416-1.64V7.307",
    fill: "#C8C7B1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.031 8.947v33.179l4.416-1.64V7.307",
    stroke: "red",
    strokeWidth: 0.013
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m13.742 22.067 10.723 3.785V48.56l-10.723-3.785V22.067z",
    fill: "#3D6627",
    stroke: "#C8C7B1",
    strokeWidth: 0.114
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m24.464 25.852 18.293-6.938v22.708L24.464 48.56",
    fill: "#3D6627"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m24.464 25.852 18.293-6.938v22.708L24.464 48.56",
    stroke: "#C8C7B1",
    strokeWidth: 0.114
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m13.742 22.068 19.553-6.939 9.336 3.785-18.166 6.938-10.723-3.784z",
    fill: "#7E976E",
    stroke: "#274116",
    strokeWidth: 0.126
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m15.382 22.067 17.914-6.307 7.821 3.154-16.652 6.307-8.957-3.154",
    stroke: "#3D6627",
    strokeWidth: 0.252
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m13.742 23.329 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262 10.723 3.785zm0 1.261 10.723 3.785zm0 1.262 10.723 3.785zm0 1.261 10.723 3.785zm0 1.262 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785z",
    fill: "#CCE0D1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m13.742 23.329 10.723 3.784M13.742 24.59l10.723 3.785m-10.723-2.523 10.723 3.784m-10.723-2.523 10.723 3.785m-10.723-2.523 10.723 3.784m-10.723-2.523 10.723 3.785m-10.723-2.523 10.723 3.784M13.742 32.16l10.723 3.785m-10.723-2.523 10.723 3.785m-10.723-2.524 10.723 3.785m-10.723-2.523 10.723 3.785m-10.723-2.523 10.723 3.784m-10.723-2.523 10.723 3.785m-10.723-2.523 10.723 3.784M13.742 40.99l10.723 3.785m-10.723-2.523 10.723 3.784m-10.723-2.523 10.723 3.785",
    stroke: "#274116",
    strokeWidth: 0.252
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m24.464 27.114 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261L42.63 22.7zm0 1.262L42.63 23.96zm0 1.261 18.166-6.938zm0 1.262 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261L42.63 31.53zm0 1.262L42.63 32.79zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261L42.63 39.1zm0 1.262L42.63 40.36z",
    fill: "#CCE0D1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m24.464 27.114 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2L42.63 22.7m-18.166 8.2L42.63 23.96m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2L42.63 31.53m-18.166 8.2L42.63 32.79m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2L42.63 39.1m-18.166 8.2L42.63 40.36",
    stroke: "#274116",
    strokeWidth: 0.252
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m21.185 19.292 9.588 3.784 4.415-1.64-9.461-3.784",
    fill: "#E5E5D5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m21.185 19.292 9.588 3.784 4.415-1.64-9.461-3.784",
    stroke: "#E5E5D5",
    strokeWidth: 0.013
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.773 23.076v23.087l4.415-1.64V21.436",
    fill: "#C8C7B1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.773 23.076v23.087l4.415-1.64V21.436",
    stroke: "red",
    strokeWidth: 0.013
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m26.357 36.07 10.723 3.785V52.47l-10.723-3.784V36.07z",
    fill: "#3D6627",
    stroke: "#C8C7B1",
    strokeWidth: 0.114
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m37.08 39.855 18.292-6.938v12.615L37.08 52.471",
    fill: "#3D6627"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m37.08 39.855 18.292-6.938v12.615L37.08 52.471",
    stroke: "#C8C7B1",
    strokeWidth: 0.114
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m26.357 36.07 19.554-6.938 9.335 3.785-18.166 6.938-10.723-3.784z",
    fill: "#7E976E",
    stroke: "#274116",
    strokeWidth: 0.126
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m27.997 36.07 17.914-6.307 7.822 3.154-16.653 6.308-8.957-3.154",
    stroke: "#3D6627",
    strokeWidth: 0.252
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m26.357 37.332 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261L37.08 43.64zm0 1.262L37.08 44.9zm0 1.261 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261 10.723 3.785zm0 1.262 10.723 3.784zm0 1.261L37.08 51.21z",
    fill: "#CCE0D1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m26.357 37.332 10.723 3.785m-10.723-2.523 10.723 3.784m-10.723-2.523L37.08 43.64m-10.723-2.523L37.08 44.9m-10.723-2.523 10.723 3.785M26.357 43.64l10.723 3.784m-10.723-2.523 10.723 3.785m-10.723-2.523 10.723 3.784m-10.723-2.523L37.08 51.21",
    stroke: "#274116",
    strokeWidth: 0.252
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m37.08 41.116 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261 18.166-6.938zm0 1.262 18.166-6.939zm0 1.261 18.166-6.938z",
    fill: "#CCE0D1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m37.08 41.116 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2 18.166-6.938M37.08 44.9l18.166-6.939m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2 18.166-6.938m-18.166 8.2 18.166-6.939m-18.166 8.2 18.166-6.938",
    stroke: "#274116",
    strokeWidth: 0.252
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m33.8 33.295 9.588 3.785 4.415-1.64-9.461-3.785",
    fill: "#E5E5D5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m33.8 33.295 9.588 3.785 4.415-1.64-9.461-3.785",
    stroke: "#E5E5D5",
    strokeWidth: 0.013
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.388 37.08v12.993l4.415-1.64V35.44",
    fill: "#C8C7B1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.388 37.08v12.993l4.415-1.64V35.44",
    stroke: "red",
    strokeWidth: 0.013
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseeyes);
export default __webpack_public_path__ + "static/media/expenseeyes.feee7138e91066a747d29d20f87e7692.svg";
export { ForwardRef as ReactComponent };